import type { Tenant } from 'shared/types/tenant'
import { t } from 'shared/i18n'
import { getTenantStorageUrl } from './url'

export const isAgencyTenant = (tenant?: Tenant): boolean => {
  return tenant?.configuration?.agency === 'enabled'
}

export interface HelpCenter {
  url: string
  label: string
}

/**
 * テナント別のヘルプ導線(URL/ラベル)。sooki だけ取扱説明書(PDF)。
 * 画面からは useTenantBranding の helpCenterUrl / helpCenterLabel を通して使う。
 */
export const getHelpCenter = (tenantName?: string): HelpCenter => {
  if (tenantName === 'sooki') {
    return { url: `${getTenantStorageUrl(tenantName)}/public/manual.pdf`, label: t('shared.tenant.label') }
  }
  return { url: 'https://help.jizaipad.com/ja', label: t('shared.tenant.label2') }
}

export const getServiceName = (tenantName?: string): string => {
  switch (tenantName) {
    case 'sooki':
      return 'Rabbit Live';
    case 'kanamoto':
      return 'kanaReco';
    case 'aktio':
      return 'AktioEyes';
    default:
      return 'JIZAIPAD';
  }
}
